'use strict';

var ConfigurationUserReferenceDataDTDRenderersFactory = function ConfigurationUserReferenceDataDTDRenderersFactory($interpolate) {
  var messageTemplate = $interpolate('<a href="#" data-click="true" uid="{{uid}}" field-id="{{fieldId}}">Set DTD</a>');
  var userReferenceDataDTDRenderer = function userReferenceDataDTDRenderer(columnContext, row, columnfield, value, defaultvalue) {
    var data = {
      uid: row,
      fieldId: columnfield
    };
    return defaultvalue.replace('>' + value + '<', '>' + messageTemplate(data) + '<');
  };
  return {
    userReferenceDataDTDView: userReferenceDataDTDRenderer
  };
};
ConfigurationUserReferenceDataDTDRenderersFactory.$inject = ['$interpolate'];
module.exports = ConfigurationUserReferenceDataDTDRenderersFactory;